import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/roi/missed-call-text-conversion')({
  staticData: { team: 'analytics' },
});
